<div class="matero-page-header-inner">
  <h1 class="matero-page-title">{{title | translate}} <small>{{subtitle}}</small></h1>
  <smhfs-fe-breadcrumb *ngIf="!hideBreadcrumb" [nav]="nav"></smhfs-fe-breadcrumb>
</div>
